import type { RequestType } from "./persistence";

export interface QueryExecutionResult {
  requestType?: RequestType;
  data?: unknown;
  errors?: unknown[];
  statusCode: number;
  durationMs: number;
  responseHeaders?: Record<string, string>;
  responseBody?: string;
  responseContentType?: string;
  command?: string;
  rowCount?: number;
}

export type TabularResultRow = Record<string, unknown>;

function isTabularResultRow(value: unknown): value is TabularResultRow {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

export function extractSqlTabularRows(result: QueryExecutionResult | null | undefined): TabularResultRow[] | null {
  if (!result || result.requestType !== "sql" || !Array.isArray(result.data)) {
    return null;
  }

  const rows = result.data.filter(isTabularResultRow);
  return rows.length === result.data.length ? rows : null;
}
